<template>
  <v-layout align-center justify-center>
    <div>
      <SignIn />
    </div>
  </v-layout>
</template>

<script>
import SignIn from "@/components/SignIn.vue";
import LoginFullPageLayout from "../layouts/LoginFullPageLayout";

export default {
  components: {
    SignIn
  },
  created() {
    this.$emit(`update:layout`, LoginFullPageLayout);
  }
};
</script>

<style scoped>
@import "../assets/style.css";
</style>